import { Icons } from "../../../shared";

/**
 * Shown when a facility has no devices reporting — FacilityCountingMode.Unknown.
 *
 * The mode is derived from each device's OperationMode (see FacilityProvider.GetCountingMode), so a
 * location with any device resolves to Occupancy, In/Out or both; Unknown means there is nothing
 * assigned here to report either kind of data. That is deliberately *not* about the layout: zones
 * and screen lines are how the counts get interpreted, but a drawing on its own produces no rows.
 *
 * Deliberately says what the view is for and what's missing, rather than rendering an empty page
 * that looks broken.
 */
export const ParkingViewUnconfigured: React.FC = () => (
    <div className="h-full flex flex-col items-center justify-center text-center gap-3 p-8">
        <Icons.Parking className="w-12 h-12 text-muted-body-text" />
        <h2 className="text-lg font-semibold">No devices are reporting at this location</h2>
        <p className="text-sm text-semi-bright-text max-w-md">
            This view counts vehicles from what the radars here are set to report: a device in
            Parking Monitor mode reports how many spaces are occupied, and any other mode reports
            vehicles crossing in and out. This location has no devices assigned to it yet.
        </p>
        <p className="text-sm text-semi-bright-text max-w-md">
            Add a device on the Devices tab, and this view will follow whichever way its operation
            mode counts. You'll also want detection zones drawn for the spaces you want monitored,
            or screen lines with a direction on the entry and exit, so there's something for those
            counts to refer to.
        </p>
    </div>
);
